import React, { useState } from 'react';
import * as api from '../services/api';

export default function SharePointUpload({ linkedEntityType, linkedEntityId, showToast }) {
  const [form, setForm] = useState({ folder_path: '', category: '', linked_ref: '', notes: '' });
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [feedback, setFeedback] = useState(null);

  async function handleUpload() {
    if (!file) { showToast('Please select a file'); return; }
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      // Only send folder_path if user entered one — backend will pick the right default
      if (form.folder_path && form.folder_path.trim()) {
        formData.append('folder_path', form.folder_path.trim());
      }
      formData.append('category', form.category);
      if (linkedEntityType) formData.append('linked_entity_type', linkedEntityType);
      // Only send linked_entity_id if it looks like a valid UUID (prevents DB cast error)
      if (linkedEntityId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(linkedEntityId)) {
        formData.append('linked_entity_id', linkedEntityId);
      }
      formData.append('description', form.notes);
      const { data } = await api.uploadDocument(formData);
      setFeedback(`Upload successful. ${file.name} uploaded to SharePoint.`);
      setFile(null);
      setTimeout(() => setFeedback(null), 8000);
    } catch (err) {
      showToast('Upload failed: ' + (err.response?.data?.error || err.message));
    } finally { setUploading(false); }
  }

  return (
    <div className="card" style={{marginTop:18}}>
      <div className="card-title">📎 SharePoint Document Upload</div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
        <div className="form-group">
          <label>SharePoint Folder Path</label>
          <input type="text" placeholder="e.g. Legal/Contracts/2025" value={form.folder_path} onChange={e => setForm({...form, folder_path: e.target.value})} />
        </div>
        <div className="form-group">
          <label>Document Category</label>
          <select value={form.category} onChange={e => setForm({...form, category: e.target.value})}>
            <option value="">-- Select Category --</option>
            <option>Contract Draft</option><option>Signed Agreement</option><option>Legal Opinion</option>
            <option>ITT Document</option><option>Court Filing</option><option>Board Resolution</option>
            <option>Meeting Minutes</option><option>Correspondence</option><option>Supporting Evidence</option>
          </select>
        </div>
        <div className="form-group">
          <label>Select File(s)</label>
          <input type="file" style={{fontSize:12,padding:7,border:'1px solid var(--border)',borderRadius:8,background:'var(--white)',width:'100%'}} onChange={e => setFile(e.target.files[0])} />
        </div>
        <div className="form-group">
          <label>Linked Reference (optional)</label>
          <input type="text" placeholder="e.g. REQ-045, AGR-2025-001" value={form.linked_ref} onChange={e => setForm({...form, linked_ref: e.target.value})} />
        </div>
        <div className="form-group" style={{gridColumn:'1/-1'}}>
          <label>Notes / Description</label>
          <input type="text" placeholder="Brief description of document(s) being uploaded" value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} />
        </div>
      </div>
      <div style={{display:'flex',justifyContent:'flex-end',gap:10,marginTop:14}}>
        <button className="topbar-btn btn-primary" onClick={handleUpload} disabled={uploading}>
          {uploading ? '⏳ Uploading...' : '☁️ Upload to SharePoint'}
        </button>
      </div>
      {feedback && <div style={{marginTop:10,padding:'10px 14px',background:'#ECFDF5',border:'1px solid #A7F3D0',borderRadius:8,fontSize:12,color:'#065F46'}}>✅ <strong>{feedback}</strong></div>}
    </div>
  );
}
